import React, { useCallback, useState } from "react";
import { addPolygonsWithColor, tempLayer, useMap } from "../../../Utils/MapUtils";
import { polygonArrayToGeometry } from "../../../Utils/MainUtils";
import { useEffect } from "react";
import { MyMap } from "../../Map/View/MyMap";
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import { _serverUrl2 } from "../../../config";
import { success } from "../../../Utils/Alerts2";
import { failed } from "../../../Utils/Alerts2";
import { Modify } from "ol/interaction.js";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import Fill from "ol/style/Fill";
import { mdiMapMarker } from "@mdi/js";
import Icon from "@mdi/react";
import { zoomToFeatureByGeojson } from "../../Map/Layers/TempLayer";
import ProjectSideBar from "./ProjectSideBar";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelector } from "react-redux";

const editedLayer = new VectorLayer({
  source: new VectorSource({
    wrapX: false,
  }),
});

export default function ProjectArea() {
  const [showButton, setShowButton] = useState(false);
  const getUserInfo = useSelector((state) => state.getUserInfo);

  const projeID = useParams().id;
  const history = useHistory();
  const MySwal = withReactContent(Swal);

  const [areas, setAreas] = useState([]);
  const [newArea, setNewArea] = useState({
    id: 0,
    bolge_adi: null,
    bolge_aciklama: null,
    geom: null,
    proje_id: projeID,
    color: null,
  });

  const durum1Areas = areas.filter((area) => area.durum === 1);
  const durum2Areas = areas.filter((area) => area.durum === 2);
  const durum3Areas = areas.filter((area) => area.durum === 3);

  const [activeAccordion, setActiveAccordion] = useState(null);

  const toggleAccordion = (index) => {
    if (activeAccordion === index) {
      setActiveAccordion(null);
    } else {
      setActiveAccordion(index);
    }
  };

  const onClickDraw = async () => {
    useMap.draw("Polygon", true).then((res) => {
      setNewArea({ ...newArea, geom: polygonArrayToGeometry(res.data.getGeometry().getCoordinates()) });
    });
  };

  const getVeri = useCallback(async () => {
    await axios.get(_serverUrl2 + "/projects/getAreas/" + projeID).then((res) => {
      setAreas(res.data.rows);
      console.log(res.data.rows, "resdatarowsareaa");
      tempLayer.getSource().clear();
      res.data.rows.map((d) => {
        return addPolygonsWithColor(d.geojson, d.color, d.bolge_adi, d.id);
      });
    });
  }, [projeID]);

  const onClickSubmit = async () => {
    if (newArea.bolge_adi == null) {
      failed("Bölge adı girilmiş olmalıdır.");
      return;
    }
    if (newArea.geom == null) {
      failed("Bölge çizilmiş olmalıdır.");
      return;
    }

    if (newArea.id != 0) {
      // setNewArea({ ...newArea, geom: polygonArrayToGeometry(tempLayer.getSource().getFeatures().filter(d => d.get('_id') == newArea.id)[0].getGeometry().getCoordinates()) })
      newArea.geom = polygonArrayToGeometry(
        tempLayer
          .getSource()
          .getFeatures()
          .filter((d) => d.get("_id") == newArea.id)[0]
          .getGeometry()
          .getCoordinates()
      );
      console.log(" newArea.id", newArea.geom);
    }

    function random_rgba() {
      var o = Math.round,
        r = Math.random,
        s = 255;
      return "rgba(" + o(r() * s) + "," + o(r() * s) + "," + o(r() * s) + "," + 0.5 + ")";
    }

    newArea.color = random_rgba();
    await axios
      .post(_serverUrl2 + "/projects/insertUpdateArea", newArea)
      .then(() => {
        success("İşlem başarılı!");
        clearValues();
        getVeri();
        if (newArea.id != 0) {
          let edraw = MyMap.getInteractions()
            .getArray()
            .find((d) => d.get("name") === "editEvent");
          MyMap.removeInteraction(edraw);
        }
      })
      .catch((er) => {
        failed("Hata oluştu. | " + er);
      });
    setShowButton(false);
  };

  const clearValues = () => {
    setNewArea({
      id: 0,
      bolge_adi: null,
      bolge_aciklama: null,
      geom: null,
      proje_id: projeID,
      color: null,
    });
    document.getElementById("_adi").value = "";
    document.getElementById("_aciklama").value = "";
  };

  const showHide = (stat) => {
    if (stat == "new") {
      let edraw = MyMap.getInteractions()
        .getArray()
        .find((d) => d.get("name") === "editEvent");
      MyMap.removeInteraction(edraw);
      editedLayer.getSource().clear();
      tempLayer.getSource().clear();
      areas.map((d) => {
        return addPolygonsWithColor(d.geojson, d.color, d.bolge_adi, d.id);
      });
      editedLayer.getSource().clear();
      if (newArea.id != 0) {
        let edraw = MyMap.getInteractions()
          .getArray()
          .find((d) => d.get("name") === "editEvent");
        MyMap.removeInteraction(edraw);
      }
      setNewArea({
        id: 0,
        bolge_adi: null,
        bolge_aciklama: null,
        geom: null,
        proje_id: projeID,
        color: null,
      });
    }
    setShowButton(!showButton);
  };

  const onClickDuzenle = async (id) => {
    console.log(MyMap.getInteractions().getArray());
    let edraw = MyMap.getInteractions()
      .getArray()
      .find((d) => d.get("name") === "editEvent");
    MyMap.removeInteraction(edraw);
    editedLayer.getSource().clear();
    tempLayer.getSource().clear();
    areas.map((d) => {
      return addPolygonsWithColor(d.geojson, d.color, d.bolge_adi, d.id);
    });
    await axios.get(_serverUrl2 + "/projects/getArea/" + id).then((res) => {
      console.log(res.data);
      let feature = tempLayer
        .getSource()
        .getFeatures()
        .filter((d) => d.get("_id") == id)[0]; //tempLayer.getSource().getFeatures()[i]
      // feature.set('_id', id)
      feature.setStyle(
        new Style({
          stroke: new Stroke({
            color: "red",
            width: 5,
          }),
          fill: new Fill({
            color: "rgba(0, 0, 255, 0.15)",
          }),
        })
      );
      editedLayer.getSource().addFeature(feature);

      const modify = new Modify({
        source: editedLayer.getSource(),
      });
      modify.set("name", "editEvent");

      setNewArea(res.data.rows[0]);
      MyMap.addInteraction(modify);
    });
    setShowButton(true);
  };

  const onClickDownload1 = async (tur) => {
    axios
      .post(_serverUrl2 + "/projects/ExcelByType/" + tur, {}, { responseType: "blob" })
      .then((res) => {
        if (res.status) {
          let date = new Date().toISOString().replace(/T/, "").replace(/\..+/, "").replace(/:/, "").toString();
          let newdate = date.replace(/:/, "");
          const filePath = newdate + "-" + tur + `.xlsx`;
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${filePath}`);
          document.body.appendChild(link);
          link.click();
          link.remove();
          success("Excel Oluşturuldu");
        }
      })
      .catch((eror) => {
        failed("Excel Alınırken Bir Hata Oluştu " + eror);
      });
  };

  const onClickExcel = async (id, ad) => {
    console.log(id);
    axios
      .get(_serverUrl2 + "/projects/getExcelVerileriGetir/" + id)
      .then((res) => {
        if (res.status) {
          console.log(res.data.rows);

          MySwal.fire({
            title: "BÖLGE " + ad,
            height: "50%",
            html: (
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <center>
                      <table className="table table-sm " style={{ width: "100%", border: "1px solid black" }}>
                        <tbody>
                          {res.data.rows.map((d) => {
                            return (
                              <tr>
                                {d.sayi == null ? null : (
                                  <>
                                    <td style={{ border: "1px solid black" }}>{d.gorev_durum}</td>
                                    <td style={{ border: "1px solid black" }}>{d.sayi}</td>
                                  </>
                                )}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </center>
                  </div>
                </div>
              </div>
            ),
            confirmButtonText: "Binaların Excel Dökümanını İndir",
            showConfirmButton: true,
            showCloseButton: true,
            showCancelButton: false,
          }).then((result) => {
            if (result.isConfirmed) {
              axios
                .post(_serverUrl2 + "/projects/excelOlustur", { id, ad }, { responseType: "blob" })
                .then((res) => {
                  if (res.status) {
                    let date = new Date().toISOString().replace(/T/, "").replace(/\..+/, "").replace(/:/, "").toString();
                    let newdate = date.replace(/:/, "");
                    const filePath = newdate + "-" + ad + `.xlsx`;
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", `${filePath}`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    success("Excel Oluşturuldu");
                  }
                })
                .catch((eror) => {
                  failed("Excel Alınırken Bir Hata Oluştu " + eror);
                });
            }
          });
        }
      })
      .catch((err) => {
        failed("Veriler Getirilirken Hata Oluştu." + err);
        return;
      });
  };

  const removeArea = (id) => {
    MySwal.fire({
      text: "Bölgeyi silmek istediğinizden emin misiniz?",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "Sil",
      cancelButtonText: "Vazgeç",
      showCloseButton: true,
    }).then((res) => {
      if (res.isConfirmed) {
        axios.get(_serverUrl2 + "/projects/delArea/" + id).then(() => {
          success("Bölge silindi!");
          getVeri();
        });
      }
    });
  };

  useEffect(() => {
    getVeri();
    //MyMap.addInteraction(modify)
    MyMap.addLayer(editedLayer);
    MyMap.addLayer(tempLayer);
    return () => {
      MyMap.removeLayer(tempLayer);
      MyMap.removeLayer(editedLayer);
      tempLayer.getSource().clear();
    };
  }, [getVeri]);

  return (
    <div className="row" style={{ fontSize: "12px" }}>
      <div className="col-12">
        <ProjectSideBar page={"2"} />
      </div>
      <div className="col-sm-12">
        <div className="textBox">
          <div className="content d-flex justify-content-between">
            <button className="orangeBtn" style={{ fontSize: "13px", width: "30px" }} onClick={() => history.goBack()}>
              <i className="fas fa-arrow-left"></i>
            </button>
            <b>Projeye Ait Bölgeler </b>
            <b>&nbsp;</b>
          </div>
        </div>
      </div>

      <div className="col-sm-4" style={{ marginLeft: "28%" }}>
        <button onClick={() => showHide("new")} className="redBtn">
          Yeni Bölge Ekle
        </button>
      </div>
      <div className="row" style={{ marginTop: "2%", marginBottom: "2%" }}>
        <div className="col-sm-4 ">
          {" "}
          <button style={{ width: "150%" }} className="greenBtn" onClick={() => onClickDownload1("SARTLI")}>
            {" "}
            <span style={{ fontWeight: "normal", color: "black" }}>Şartlı Yapılar</span>
            <i className="fas fa-download" style={{ float: "right" }}></i>
          </button>
        </div>

        <div className="col-sm-4 ">
          {" "}
          <button style={{ marginTop: "1%", marginBottom: "2%", marginLeft: "60%", width: "150%" }} className="greenBtn" onClick={() => onClickDownload1("TEKRAR")}>
            {" "}
            <span style={{ fontWeight: "normal", color: "black" }}>Tekrar Kontroldeki Yapılar</span>
            <i className="fas fa-download" style={{ float: "right" }}></i>
          </button>
        </div>
      </div>

      {showButton && (
        <>
          <div className="col-sm-6">
            <label style={{ fontWeight: "bold" }}>Bölge Adı</label>
            <input id="_adi" className="form-control form-control-sm" value={newArea.bolge_adi} onChange={(e) => setNewArea({ ...newArea, bolge_adi: e.target.value })} />
          </div>
          <div className="col-sm-12">
            <label style={{ fontWeight: "bold" }}>Bölge Açıklaması</label>
            <textarea
              id="_aciklama"
              className="form-control form-control-sm"
              value={newArea.bolge_aciklama}
              onChange={(e) => setNewArea({ ...newArea, bolge_aciklama: e.target.value })}
              style={{ maxHeight: "125px", height: "75px" }}
            />
          </div>
          <div className="col-sm-12">
            <label style={{ fontWeight: "bold" }}>Bölge Çizimi</label>
            <br />
            {newArea.geom == null ? (
              <button onClick={() => onClickDraw()} className="darkOrangeBtn">
                Çizilmedi, Çizmek için tıklayınız.
              </button>
            ) : (
              <button onClick={() => onClickDraw()} className="greenBtn">
                Alan belirlendi. Tekrar çizmek için tıklayınız
              </button>
            )}
          </div>
          <div className="col-sm-12">&nbsp;</div>
          <div className="col-sm-8">&nbsp;</div>
          <div className="col-sm-4">
            <button onClick={() => onClickSubmit()} className="greenBtn">
              Bölgeyi Kaydet
            </button>
          </div>
          <div className="col-sm-12">
            <hr />
          </div>
        </>
      )}

      <div className="col-sm-12">
        <center>
          <h5>Projeye Ait Bölgeler</h5>
        </center>
      </div>
      {/* <div className='col-sm-12' style={{height:'650px',overflowY:'auto'}}>
                <table className='table table-sm table-bordered table-striped' >
                    <thead style={{position:'sticky',top:'0px'}}>
                        <tr style={{backgroundColor:'gray'}}>
                            <td style={{ width: '10px' }} ></td>
                            <td></td>
                            <th>Bölge Adı</th>
                            <th>Bölge Açıklaması</th>
                            <td></td>
                        </tr>
                    </thead>
                    <tbody>
                        {areas.map((d, i) => {
                            return <tr key={i} >
                                <th style={{ backgroundColor: d.color }}></th>
                                <td style={{ borderLeft: '3px solid rgb(160, 202, 140)' }} onClick={() => zoomToFeatureByGeojson(d.geojson)} ><Icon path={mdiMapMarker} size={1.5} style={{ color: '#344e75', cursor: 'pointer' }} /></td>
                                <td>{d.bolge_adi}</td>
                                <td>{d.bolge_aciklama}</td>
                                <td style={{ width: '135px' }} >
                                    
                                    {getUserInfo.Rol.includes('13') ?
                    <>
                    <button style={{ margin: '2px', width: '35px' }} className='greenBtn' onClick={() => onClickExcel(d.id, d.bolge_adi, i)}><i className="far fa-eye"></i></button>
                    <button style={{ margin: '2px', width: '35px' }} className='orangeBtn' onClick={() => onClickDuzenle(d.id, i)}><i className="fas fa-pen fa-lg"></i></button>
                    <button style={{ margin: '2px', width: '35px' }} className='redBtn' onClick={() => removeArea(d.id)}><i className="fas fa-trash"></i></button></>  
                    :
                    <button style={{ margin: '2px',alignItems:'end' }} className='greenBtn' onClick={() => onClickExcel(d.id, d.bolge_adi, i)}><i className="far fa-eye"></i></button>
                    }</td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div> */}
      {/* Durum 1 için akordion */}
      <div className="accordion" style={{ marginTop: "10px" }}>
        <div className={`accordion-button ${activeAccordion === 1 ? "active" : "accordion-button collapsed bg-warning"}`} onClick={() => toggleAccordion(1)}>
          Tamamlanan Bölgeler
        </div>
        {activeAccordion === 1 && (
          <div className="accordion-content">
            <div className="col-sm-12" style={{ height: "650px", overflowY: "auto" }}>
              <table className="table table-sm table-bordered table-striped">
                <thead>
                  <tr style={{ backgroundColor: "gray" }}>
                    <td style={{ width: "10px" }}></td>
                    <td></td>
                    <th>Bölge Adı</th>
                    <th>Bölge Açıklaması</th>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {durum1Areas.map((d, i) => (
                    <tr key={i}>
                      <th style={{ backgroundColor: d.color }}></th>
                      <td style={{ borderLeft: "3px solid rgb(160, 202, 140)" }} onClick={() => zoomToFeatureByGeojson(d.geojson)}>
                        <Icon path={mdiMapMarker} size={1.5} style={{ color: "#344e75", cursor: "pointer" }} />
                      </td>
                      <td>{d.bolge_adi}</td>
                      <td>{d.bolge_aciklama}</td>
                      <td style={{ width: "135px" }}>
                        {getUserInfo.Rol.includes("13") ? (
                          <>
                            <button style={{ margin: "2px", width: "35px" }} className="greenBtn" onClick={() => onClickExcel(d.id, d.bolge_adi, i)}>
                              <i className="far fa-eye"></i>
                            </button>
                            <button style={{ margin: "2px", width: "35px" }} className="orangeBtn" onClick={() => onClickDuzenle(d.id, i)}>
                              <i className="fas fa-pen fa-lg"></i>
                            </button>
                            <button style={{ margin: "2px", width: "35px" }} className="redBtn" onClick={() => removeArea(d.id)}>
                              <i className="fas fa-trash"></i>
                            </button>
                          </>
                        ) : (
                          <button style={{ margin: "2px", alignItems: "end" }} className="greenBtn" onClick={() => onClickExcel(d.id, d.bolge_adi, i)}>
                            <i className="far fa-eye"></i>
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      {/* Durum 2 için akordion */}
      <div className="accordion" style={{ marginTop: "10px" }}>
        <div className={`accordion-button ${activeAccordion === 2 ? "active" : "accordion-button collapsed bg-warning"}`} onClick={() => toggleAccordion(2)}>
          İşlemde Olan Bölgeler
        </div>
        {activeAccordion === 2 && (
          <div className="accordion-content">
            <div className="col-sm-12" style={{ height: "650px", overflowY: "auto" }}>
              <table className="table table-sm table-bordered table-striped">
                <thead>
                  <tr style={{ backgroundColor: "gray" }}>
                    <td style={{ width: "10px" }}></td>
                    <td></td>
                    <th>Bölge Adı</th>
                    <th>Bölge Açıklaması</th>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {durum2Areas.map((d, i) => (
                    <tr key={i}>
                      <th style={{ backgroundColor: d.color }}></th>
                      <td style={{ borderLeft: "3px solid rgb(160, 202, 140)" }} onClick={() => zoomToFeatureByGeojson(d.geojson)}>
                        <Icon path={mdiMapMarker} size={1.5} style={{ color: "#344e75", cursor: "pointer" }} />
                      </td>
                      <td>{d.bolge_adi}</td>
                      <td>{d.bolge_aciklama}</td>
                      <td style={{ width: "135px" }}>
                        {getUserInfo.Rol.includes("13") ? (
                          <>
                            <button style={{ margin: "2px", width: "35px" }} className="greenBtn" onClick={() => onClickExcel(d.id, d.bolge_adi, i)}>
                              <i className="far fa-eye"></i>
                            </button>
                            <button style={{ margin: "2px", width: "35px" }} className="orangeBtn" onClick={() => onClickDuzenle(d.id, i)}>
                              <i className="fas fa-pen fa-lg"></i>
                            </button>
                            <button style={{ margin: "2px", width: "35px" }} className="redBtn" onClick={() => removeArea(d.id)}>
                              <i className="fas fa-trash"></i>
                            </button>
                          </>
                        ) : (
                          <button style={{ margin: "2px", alignItems: "end" }} className="greenBtn" onClick={() => onClickExcel(d.id, d.bolge_adi, i)}>
                            <i className="far fa-eye"></i>
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      {/* Durum 3 için akordion */}
      <div className="accordion" style={{ marginTop: "10px" }}>
        <div className={`accordion-button ${activeAccordion === 3 ? "active" : "accordion-button collapsed bg-warning"}`} onClick={() => toggleAccordion(3)}>
          Henüz Atanmamış Bölgeler
        </div>
        {activeAccordion === 3 && (
          <div className="accordion-content">
            <div className="col-sm-12" style={{ height: "650px", overflowY: "auto" }}>
              <table className="table table-sm table-bordered table-striped">
                <thead>
                  <tr style={{ backgroundColor: "gray" }}>
                    <td style={{ width: "10px" }}></td>
                    <td></td>
                    <th>Bölge Adı</th>
                    <th>Bölge Açıklaması</th>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {durum3Areas.map((d, i) => (
                    <tr key={i}>
                      <th style={{ backgroundColor: d.color }}></th>
                      <td style={{ borderLeft: "3px solid rgb(160, 202, 140)" }} onClick={() => zoomToFeatureByGeojson(d.geojson)}>
                        <Icon path={mdiMapMarker} size={1.5} style={{ color: "#344e75", cursor: "pointer" }} />
                      </td>
                      <td>{d.bolge_adi}</td>
                      <td>{d.bolge_aciklama}</td>
                      <td style={{ width: "135px" }}>
                        {getUserInfo.Rol.includes("13") ? (
                          <>
                            <button style={{ margin: "2px", width: "35px" }} className="greenBtn" onClick={() => onClickExcel(d.id, d.bolge_adi, i)}>
                              <i className="far fa-eye"></i>
                            </button>
                            <button style={{ margin: "2px", width: "35px" }} className="orangeBtn" onClick={() => onClickDuzenle(d.id, i)}>
                              <i className="fas fa-pen fa-lg"></i>
                            </button>
                            <button style={{ margin: "2px", width: "35px" }} className="redBtn" onClick={() => removeArea(d.id)}>
                              <i className="fas fa-trash"></i>
                            </button>
                          </>
                        ) : (
                          <button style={{ margin: "2px", alignItems: "end" }} className="greenBtn" onClick={() => onClickExcel(d.id, d.bolge_adi, i)}>
                            <i className="far fa-eye"></i>
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
